import type { Handlers } from '@/types/Metrics';

export default function (args: Handlers['gtm']) {
  try {
    if (!window.dataLayer) {
      return;
    }

    window.dataLayer.push(...args);
  } catch (err) {
    console.error(err);
  }
}
